import type { RouteComponentProps } from 'react-router-dom';
import { isEmbeddedSelector } from '../../selectors/offer';
import { clearSystemState } from '../../store/system';
import { openExternalLink } from '../helpers';

import type { Dispatch } from '@avalara/types/actions';
import type { State } from '@avalara/types/reducer-states';

const isRelativeUrl = (url: string) => new URL(document.baseURI).origin === new URL(url, document.baseURI).origin;

export const closeSystemErrorAndNavigate =
  (history: RouteComponentProps['history']) => (dispatch: Dispatch, getState: () => State) => {
    const state = getState();
    const {
      system: { error },
    } = state;

    if (error?.locationAfterErrorDismissal) {
      if (isEmbeddedSelector(state)) {
        window.parent.postMessage({ event: 'add-offer', success: false }, '*');
        history.push('/');
      } else if (isRelativeUrl(error.locationAfterErrorDismissal)) {
        history.push(error.locationAfterErrorDismissal);
      } else {
        openExternalLink(error.locationAfterErrorDismissal);
      }
    }

    dispatch(clearSystemState());
  };
